import React from 'react';

const InfoIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'>
    <g fill='none' fillRule='evenodd' stroke='#BDBDBD' transform='translate(1 1)'>
      <circle cx='6.5' cy='6.5' r='6.5' strokeWidth='2' />
      <rect width='1' height='3.643' x='6.071' y='6.071' rx='.5' />
      <rect width='1' height='1' x='6.071' y='3.286' rx='.5' />
    </g>
  </svg>
);

export default InfoIcon;
